import React, { ReactNode } from 'react';
import { useSafeArea } from '../hooks/useSafeArea';

interface SafeAreaWrapperProps {
    children: ReactNode;
    /** 是否应用顶部安全区域 */
    top?: boolean;
    /** 是否应用底部安全区域 */
    bottom?: boolean;
    /** 是否应用左侧安全区域 */
    left?: boolean;
    /** 是否应用右侧安全区域 */
    right?: boolean;
    /** 自定义CSS类名 */
    className?: string;
    /** 是否为钉钉环境优化 */
    dingTalkOptimized?: boolean;
    /** 额外的顶部间距（像素） */
    extraTopPadding?: number;
}

/**
 * 安全区域包装组件
 * 用于处理刘海屏、钉钉环境等的安全区域适配
 */
const SafeAreaWrapper: React.FC<SafeAreaWrapperProps> = ({
    children,
    top = true,
    bottom = false,
    left = false,
    right = false,
    className = '',
    dingTalkOptimized = true,
    extraTopPadding = 0
}) => {
    const {
        generateSafeAreaStyle,
        getSafeAreaClasses,
        isDingTalk,
        needsSafeAreaAdaptation
    } = useSafeArea();

    // 如果不需要安全区域适配，直接返回子组件
    if (!needsSafeAreaAdaptation()) {
        return <div className={className}>{children}</div>;
    }

    // 生成样式和类名
    const safeAreaStyle = generateSafeAreaStyle({
        top,
        bottom,
        left,
        right,
        extraTop: extraTopPadding
    });

    const safeAreaClasses = getSafeAreaClasses({
        top,
        bottom,
        left,
        right,
        dingTalkOptimized
    });

    const finalClassName = [className, safeAreaClasses].filter(Boolean).join(' ');

    return (
        <div
            className={finalClassName}
            style={safeAreaStyle}
        >
            {children}
        </div>
    );
};

export default SafeAreaWrapper;
